module.exports = __webpack_public_path__ + "static/media/utthita.ddd5c987.png";